// Post-login redirect helper.
//
// `reroute` is normally an in-app path, so the login screens hand it to
// react-router. Some paths under sotravel.com are NOT served by this SPA:
// /guides/* is the Astro landing-pages app reached through an Amplify
// reverse-proxy rewrite. A client-side navigate() to one of those would render
// the SPA's 404 shell instead of the page, so they need a full page load.
// Trip pages (/trips, /trip, /t) go to the Astro app too, which renders the
// rolled-out projects and hands the others back to this app.
const EXTERNAL_PATH_PREFIXES = ["/guides", "/trips", "/trip", "/t"];
const DOMAIN_LIKE_CTA = /^[a-z0-9.-]+\.[a-z]{2,}(?::\d+)?(?:[/?#]|$)/i;

export const isExternalReroute = (reroute) =>
  typeof reroute === "string" &&
  EXTERNAL_PATH_PREFIXES.some(
    (prefix) =>
      reroute === prefix || reroute.startsWith(`${prefix}/`) || reroute.startsWith(`${prefix}?`)
  );

export const followReroute = (navigate, reroute) => {
  if (isExternalReroute(reroute)) {
    window.location.assign(reroute);
    return;
  }
  navigate(reroute);
};

// Promotion CTAs can be internal paths, absolute URLs, or protocol-less URLs
// entered in admin. Resolve them consistently and flag destinations that must
// leave the React SPA (external origins and /guides/*).
export const resolveCtaNavigation = (cta, currentOrigin) => {
  if (typeof cta !== "string" || !cta.trim() || !currentOrigin) return null;

  const value = cta.trim();
  const normalized = DOMAIN_LIKE_CTA.test(value) ? `https://${value}` : value;

  try {
    const url = new URL(normalized, currentOrigin);
    if (url.protocol !== "http:" && url.protocol !== "https:") return null;

    const path = `${url.pathname}${url.search}${url.hash}`;
    return {
      href: url.href,
      path,
      requiresDocumentNavigation:
        url.origin !== new URL(currentOrigin).origin || isExternalReroute(url.pathname),
    };
  } catch {
    return null;
  }
};
